export const calcCoins = (enteredCoins) => {
    var standartPrice = Math.round(enteredCoins / 3)
    if (enteredCoins >= 100) {
      standartPrice = Math.round(enteredCoins / 4)
    }
    if (enteredCoins >= 500) {
      standartPrice = Math.round(enteredCoins / 5.05)
    }
    if (enteredCoins >= 1000) {
      standartPrice = Math.round(enteredCoins / 6.3)
    }
    if (enteredCoins >= 5000) {
      standartPrice = Math.round(enteredCoins / 7.16)
    }
    if (enteredCoins >= 10000) {
      standartPrice = Math.round(enteredCoins / 8)
    }
    return standartPrice
}
export const calcStandartPrice = (enteredCoins) => {
    var standartPrice = Math.round(enteredCoins / 3)
    return standartPrice
}